import { Flex } from '@tonic-one/react';
import { useDashboardDaysStore } from 'src/models/useDashboardDaysModel';
import { DashboardPeriod } from '@Types/dashboard';

import Organization from '../../../components/Common/Organization';
import RiskUserRecipient from './TargetedAttackRisk';
import SpamGraymailSender from './SpamGraymailSender';
import RiskUserTrend from './UserRiskAnalytics';
import ServiceCheckbox from '../ServiceCheckbox';
import AccountTakeoverRisk from './AccountTakeoverRisk';
import { useDashboardWidget } from '../useDashboardWidget';

const RiskUser = () => {
  const daysModel = useDashboardDaysStore();

  const insightsPeriod =
    (daysModel.days['TopAccountTakeoverRiskChart'] as DashboardPeriod) ||
    DashboardPeriod.last24h;
  const eventPeriod =
    (daysModel.days['AtRiskUserTrends'] as DashboardPeriod) ||
    DashboardPeriod.last24h;

  const { data: insightsData } = useDashboardWidget(
    'riskInsights',
    insightsPeriod
  );
  const { data: eventData } = useDashboardWidget('riskEvent', eventPeriod);

  return (
    <>
      <Flex m="24px 16px" gap="24px">
        <Organization />
        <ServiceCheckbox />
      </Flex>
      <Flex width="100%" direction="column" p="0 16px">
        <AccountTakeoverRisk insightsData={insightsData || {}} />
        <RiskUserRecipient insightsData={insightsData || {}} />
        <SpamGraymailSender insightsData={insightsData || {}} />
        <RiskUserTrend eventData={eventData || {}} />
      </Flex>
    </>
  );
};

export default RiskUser;
